import { Reducer } from "redux";

import {
	Template,
	TemplateFilterType,
	TemplatesCount,
	TemplateSidePanelEnum
} from "@/Contracts/Templates";
import {
	TemplatesActions,
	TemplatesActionTypes
} from "../../Actions/Templates";

export interface TemplatesState {
	readonly isLoading: boolean;
	readonly isTemplateSidePanelOpen: boolean;
	readonly isModalLoading: boolean;
	readonly templateList: Template[];
	readonly templatesCount: TemplatesCount;
	readonly currentActiveTemplate: Template | null;
	readonly activeTab: TemplateFilterType;
	readonly activeTemplatePanel: TemplateSidePanelEnum | null;
	readonly isTemplatePreviewModalOpen: boolean;
	readonly addTemplateRequested: boolean;
}

export const initialTemplateState: TemplatesState = {
	isTemplateSidePanelOpen: true,
	isLoading: false,
	isModalLoading: false,
	templateList: new Array<Template>(),
	templatesCount: new TemplatesCount(),
	currentActiveTemplate: null,
	activeTab: TemplateFilterType.Global,
	isTemplatePreviewModalOpen: false,
	activeTemplatePanel: TemplateSidePanelEnum.EDIT,
	addTemplateRequested: false
};

export const TemplatesReducer: Reducer<TemplatesState, TemplatesActions> = (
	state: TemplatesState = initialTemplateState,
	action: TemplatesActions
): TemplatesState => {
	switch (action.type) {
		case TemplatesActionTypes.SHOW_TEMPLATES_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case TemplatesActionTypes.HIDE_TEMPLATES_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case TemplatesActionTypes.GET_TEMPLATES_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.GET_TEMPLATES_SUCCESSFUL: {
			return {
				...state,
				templateList: action.templateList,
				templatesCount: action.templateCount
			};
		}
		case TemplatesActionTypes.GET_TEMPLATES_FAILED: {
			return state;
		}
		case TemplatesActionTypes.RESET_TEMPLATES_LIST: {
			return {
				...state,
				templateList: new Array<Template>()
			};
		}
		case TemplatesActionTypes.TEMPLATE_DETAILS_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.TEMPLATE_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveTemplate: action.currentActiveTemplate
			};
		}
		case TemplatesActionTypes.TEMPLATE_DETAILS_FAILED: {
			return state;
		}
		case TemplatesActionTypes.CHANGE_TEMPLATE_ACTIVE_TAB: {
			return { ...state, activeTab: action.activeTab };
		}

		case TemplatesActionTypes.GET_TEMPLATE_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveTemplate: action.currentActiveTemplate
			};
		}

		case TemplatesActionTypes.RESET_TEMPLATE_DETAILS: {
			return {
				...state,
				currentActiveTemplate: null,
				activeTemplatePanel: TemplateSidePanelEnum.EDIT
			};
		}

		case TemplatesActionTypes.OPEN_TEMPLATE_PREVIEW_MODAL: {
			return { ...state, isTemplatePreviewModalOpen: true };
		}

		case TemplatesActionTypes.CLOSE_TEMPLATE_PREVIEW_MODAL: {
			return { ...state, isTemplatePreviewModalOpen: false };
		}

		case TemplatesActionTypes.SHOW_TEMPLATE_MODAL_LOADER: {
			return { ...state, isModalLoading: true };
		}

		case TemplatesActionTypes.HIDE_TEMPLATE_MODAL_LOADER: {
			return { ...state, isModalLoading: false };
		}

		case TemplatesActionTypes.UPDATE_TEMPLATE_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveTemplate: action.currentActiveTemplate
			};
		}

		case TemplatesActionTypes.SET_TEMPLATE_SIDE_PANEL: {
			return { ...state, activeTemplatePanel: action.templateSidePanel };
		}

		case TemplatesActionTypes.UPDATE_TEMPLATE_DETAILS_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.UPDATE_TEMPLATE_DETAILS_FAILED: {
			return state;
		}

		case TemplatesActionTypes.DELETE_TEMPLATE_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.DELETE_TEMPLATE_FAILED: {
			return state;
		}
		case TemplatesActionTypes.GET_TEMPLATE_DETAILS_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.GET_TEMPLATE_DETAILS_FAILED: {
			return state;
		}
		case TemplatesActionTypes.UPDATE_MERGE_TAG_SUCCESSFUL: {
			if (state.currentActiveTemplate) {
				return {
					...state,
					currentActiveTemplate: {
						...state.currentActiveTemplate,
						merge_tag_custom_variables:
							action.customMergeTagVariables ||
							state.currentActiveTemplate
								.merge_tag_custom_variables
					}
				};
			} else {
				return state;
			}
		}
		case TemplatesActionTypes.UPDATE_MERGE_TAG_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.UPDATE_MERGE_TAG_FAILED: {
			return state;
		}
		case TemplatesActionTypes.UPDATE_SIGNATURE_ASSIGNEE_REQUESTED: {
			return state;
		}
		case TemplatesActionTypes.UPDATE_SIGNATURE_ASSIGNEE_SUCCESSFUL: {
			return {
				...state,
				currentActiveTemplate: action.response
			};
		}
		case TemplatesActionTypes.UPDATE_SIGNATURE_ASSIGNEE_FAILED: {
			return state;
		}
		case TemplatesActionTypes.ADD_TEMPLATE_REQUESTED: {
			return {
				...state,
				addTemplateRequested: true
			};
		}
		case TemplatesActionTypes.ADD_TEMPLATE_FAILED: {
			return {
				...state,
				addTemplateRequested: false
			};
		}
		case TemplatesActionTypes.ADD_TEMPLATE_SUCCESSFUL: {
			return {
				...state,
				addTemplateRequested: false
			};
		}
		case TemplatesActionTypes.OPEN_TEMPLATE_SIDE_PANEL: {
			return {
				...state,
				isTemplateSidePanelOpen: true
			};
		}
		case TemplatesActionTypes.CLOSE_TEMPLATE_SIDE_PANEL: {
			return {
				...state,
				isTemplateSidePanelOpen: false
			};
		}
		default: {
			return state;
		}
	}
};

export default TemplatesReducer;
